import { useEffect, useState } from "react";
import { Check, Loader2 } from "lucide-react";

const EXAMPLES = [
  { t: "Avtoyuma məntəqəm var", r: ["Online rezervasiya", "QR Loyalty", "Google rəyləri"] },
  { t: "Restoranım var", r: ["Online sifariş", "Çatdırılma", "Bonus sistemi"] },
  { t: "TikTok-da canlı yayım edirəm", r: ["TikTok Race", "Gift Game", "TikTok Çarx"] },
];
const reduced = typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export default function AdvisorLoop() {
  const [ex, setEx] = useState(0);
  const [chars, setChars] = useState(reduced ? EXAMPLES[0].t.length : 0);
  const [phase, setPhase] = useState(reduced ? "results" : "typing");
  const [shown, setShown] = useState(reduced ? 3 : 0);
  const e = EXAMPLES[ex];

  useEffect(() => {
    if (reduced) return;
    let t;
    if (phase === "typing") {
      t = chars < e.t.length ? setTimeout(() => setChars(chars + 1), 55) : setTimeout(() => setPhase("analyzing"), 400);
    } else if (phase === "analyzing") {
      t = setTimeout(() => setPhase("results"), 900);
    } else if (shown < e.r.length) {
      t = setTimeout(() => setShown(shown + 1), 260);
    } else {
      t = setTimeout(() => { setEx((ex + 1) % EXAMPLES.length); setChars(0); setShown(0); setPhase("typing"); }, 2200);
    }
    return () => clearTimeout(t);
  }, [phase, chars, shown, ex, e]);

  return (
    <span className="relative block w-full lg:w-[340px] shrink-0 rounded-2xl border border-white/10 bg-[#0c0c0b]/70 p-3 h-[122px] overflow-hidden" aria-hidden="true" data-testid="advisor-loop">
      <span className="flex items-center gap-2 rounded-lg bg-white/[0.05] px-3 py-2 text-[13px] text-[#F3EEE4]">
        <span className="truncate">{e.t.slice(0, chars)}</span>
        {phase === "typing" && <span className="w-px h-4 bg-[#D6AD62] animate-pulse shrink-0" />}
        {phase === "analyzing" && <Loader2 size={14} className="ml-auto text-[#D6AD62] animate-spin shrink-0" />}
        {phase === "results" && <Check size={14} className="ml-auto text-[#D6AD62] shrink-0" />}
      </span>
      <span className="flex flex-wrap gap-1.5 mt-2.5">
        {phase === "analyzing" && <span className="text-[11px] text-[#a9a398]">Uyğun həllər seçilir...</span>}
        {phase === "results" && e.r.slice(0, shown).map((r) => (
          <span key={r} className="fade-up inline-flex items-center gap-1 rounded-full bg-[#D6AD62]/15 border border-[#D6AD62]/40 text-[#F3D592] px-2.5 py-1 text-[11px] font-semibold">
            <Check size={11} /> {r}
          </span>
        ))}
      </span>
    </span>
  );
}
